<template>
  <div class="teacher-awards">
    <div class="teacher-awards-toolbar">
      <div>
        <div class="page-title">学生成绩</div>
        <div class="page-subtitle">{{ students.length }} 名有成绩学生</div>
      </div>
      <div class="toolbar-actions">
        <div class="session-title" @click="exportAllTranscripts">下载全部成绩单</div>
        <div class="session-title1" @click="exportAllAwards">下载全部证书</div>
      </div>
    </div>

    <div class="teacher-awards-layout">
      <div class="student-list">
        <el-input
          v-model="keyword"
          size="small"
          prefix-icon="el-icon-search"
          placeholder="搜索学生"
        />
        <div v-if="studentsLoading" class="empty-text">Loading...</div>
        <div v-else-if="filteredStudents.length === 0" class="empty-text">暂无有成绩学生</div>
        <div v-else class="student-items">
          <div
            v-for="student in filteredStudents"
            :key="student.student_id"
            :class="{ 'student-row': true, active: selectedStudent && selectedStudent.student_id === student.student_id }"
            @click="selectStudent(student)"
          >
            <div class="student-name">{{ student.student_name || student.student_email }}</div>
            <div class="student-meta">{{ student.account_name }}</div>
            <div class="student-email">{{ student.student_email }}</div>
          </div>
        </div>
      </div>

      <div class="award-detail">
        <div v-if="!selectedStudent" class="empty-text">请选择学生</div>
        <template v-else>
          <div class="selected-head">
            <div class="selected-info">
              <div class="selected-name">{{ selectedStudent.student_name || selectedStudent.student_email }}</div>
              <div class="selected-meta">{{ selectedStudent.account_name }} {{ selectedStudent.student_email }}</div>
            </div>
            <div class="student-actions">
              <div class="session-title" @click="toTranscript">查看电子成绩单</div>
              <div class="session-title1" @click="exportTranscript">下载成绩单</div>
              <div class="session-title1" @click="exportAward">下载证书</div>
            </div>
          </div>

          <div v-if="detailLoading" class="empty-text">Loading...</div>
          <template v-else>
            <div v-if="riseStr != ''" class="rise_name">全国精英赛晋级情况：{{ riseStr }}</div>

            <div v-if="rankList.length === 0" class="empty-text">暂无成绩数据</div>
            <div v-else class="my-events">
              <div v-for="(item, index) in rankList" :key="getScoreKey(item, index)">
                <div class="events-item">
                  <div style="padding: 0px 36px; position: relative; width: 100%">
                    <div class="event_name">{{ item.application_event }}</div>
                    <div class="scoreLable">
                      {{ "Score：" + item.total_score + " / " + item.full_score }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  checkTranscriptOpen,
  findMyTranscript,
  getEducatorAwardStudents,
  getStudentAwardRise
} from '../../../api/index'
import { getProjectCode, getUserId } from '../../../utils/store'
import '../../../assets/common/font.css'

export default {
  name: 'TeacherAwards',
  data () {
    return {
      students: [],
      selectedStudent: null,
      rankList: [],
      riseStr: '',
      keyword: '',
      studentsLoading: false,
      detailLoading: false
    }
  },
  computed: {
    filteredStudents () {
      const keyword = String(this.keyword || '').trim().toLowerCase()
      if (!keyword) return this.students
      return this.students.filter((student) => {
        return [
          student.student_name,
          student.student_email,
          student.account_name
        ].some((value) => String(value || '').toLowerCase().indexOf(keyword) !== -1)
      })
    }
  },
  mounted () {
    this.fetchStudents()
  },
  methods: {
    fetchStudents () {
      this.studentsLoading = true
      getEducatorAwardStudents(getProjectCode(), getUserId()).then((res) => {
        if (res.data.code === 0) {
          this.setStudentsWithScores(res.data.data || [])
        } else {
          this.studentsLoading = false
          this.$message.error(res.data.msg || '学生列表加载失败')
        }
      }).catch(() => {
        this.studentsLoading = false
        this.$message.error('学生列表加载失败')
      })
    },
    setStudentsWithScores (students) {
      const requests = students.map((student) => {
        return findMyTranscript(student.student_id, getProjectCode()).then((res) => {
          const scoreInfo = res.data.code === 0 ? this.getScoreInfo(res.data.data) : []
          return {
            student,
            hasScore: scoreInfo.length > 0
          }
        }).catch(() => {
          return {
            student,
            hasScore: false
          }
        })
      })

      Promise.all(requests).then((results) => {
        this.studentsLoading = false
        this.students = results
          .filter((item) => item.hasScore)
          .map((item) => item.student)
        this.selectedStudent = null
        this.rankList = []
        this.riseStr = ''

        if (this.students.length > 0) {
          this.selectStudent(this.students[0])
        }
      }).catch(() => {
        this.studentsLoading = false
        this.$message.error('学生列表加载失败')
      })
    },
    selectStudent (student) {
      this.selectedStudent = student
      this.fetchStudentAward(student.student_id)
    },
    fetchStudentAward (studentId) {
      this.detailLoading = true
      this.rankList = []
      this.riseStr = ''

      findMyTranscript(studentId, getProjectCode()).then((res) => {
        this.detailLoading = false
        if (res.data.code === 0 && res.data.data && res.data.data.score_info) {
          this.rankList = this.getScoreInfo(res.data.data)
        }
      }).catch(() => {
        this.detailLoading = false
        this.$message.error('成绩加载失败')
      })

      getStudentAwardRise(getProjectCode(), studentId).then((res) => {
        if (res.data.code === 0 && res.data.data) {
          this.riseStr = res.data.data.award_rise || ''
        }
      })
    },
    getScoreKey (item, index) {
      return item && item._id && item._id.$id ? item._id.$id : index
    },
    getScoreInfo (transcript) {
      const scoreInfo = transcript && transcript.score_info ? transcript.score_info : []
      if (!Array.isArray(scoreInfo)) return []
      return scoreInfo.filter((info) => !info.project_code || info.project_code === getProjectCode())
    },
    checkOpenAndGo (path, query) {
      checkTranscriptOpen(getProjectCode()).then((res) => {
        if (res.data) {
          this.$router.push({ path, query })
        } else {
          this.$message.error('电子成绩单还未公布，请稍后再来查看')
        }
      })
    },
    toTranscript () {
      if (!this.selectedStudent) return
      this.checkOpenAndGo('/transcript', { student_id: this.selectedStudent.student_id })
    },
    exportTranscript () {
      if (!this.selectedStudent) return
      this.checkOpenAndGo('/awardExportTran', { student_id: this.selectedStudent.student_id })
    },
    exportAward () {
      if (!this.selectedStudent) return
      this.checkOpenAndGo('/awardExport', { student_id: this.selectedStudent.student_id })
    },
    exportAllTranscripts () {
      if (this.students.length === 0) {
        this.$message.warning('暂无可下载学生')
        return
      }
      this.checkOpenAndGo('/awardExportTran', { student_ids: this.getStudentIds().join(',') })
    },
    exportAllAwards () {
      if (this.students.length === 0) {
        this.$message.warning('暂无可下载学生')
        return
      }
      this.checkOpenAndGo('/awardExport', { student_ids: this.getStudentIds().join(',') })
    },
    getStudentIds () {
      return this.students.map((student) => student.student_id).filter((studentId) => studentId)
    }
  }
}
</script>

<style lang="less" scoped>
.teacher-awards {
  width: 1100px;
  margin: 20px auto;
  color: #00348b;
  font-family: Montserrat-SemiBold, Microsoft YaHei;
}

.teacher-awards-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.page-title {
  font-size: 28px;
  font-weight: 900;
}

.page-subtitle {
  margin-top: 4px;
  color: #6d7ba6;
  font-size: 14px;
}

.toolbar-actions,
.student-actions {
  display: flex;
  align-items: center;
}

.student-actions {
  flex-shrink: 0;
}

.teacher-awards-layout {
  display: grid;
  grid-template-columns: 310px 1fr;
  gap: 24px;
  min-height: 640px;
}

.student-list {
  background: #f2f5ff;
  border: 1px solid #d8e0fb;
  padding: 14px;
  overflow: hidden;
}

.student-items {
  margin-top: 12px;
  max-height: 610px;
  overflow-y: auto;
}

.student-row {
  min-width: 0;
  padding: 12px;
  margin-bottom: 10px;
  background: #fff;
  border-left: 4px solid transparent;
  cursor: pointer;
}

.student-row.active {
  border-left-color: #00348b;
  background: #e4eaff;
}

.student-name {
  font-size: 17px;
  font-weight: 900;
  color: #00348b;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.student-meta,
.student-email,
.selected-meta {
  margin-top: 4px;
  color: #6d7ba6;
  font-size: 13px;
  line-height: 1.4;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.award-detail {
  min-width: 0;
}

.selected-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.selected-info {
  flex: 1;
  min-width: 0;
  padding-right: 16px;
}

.selected-name {
  font-size: 24px;
  font-weight: 900;
  color: #00348b;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.empty-text {
  padding: 34px 0;
  text-align: center;
  color: #6d7ba6;
}

.rise_name {
  font-size: 28px;
  margin-left: 20px;
  margin-top: 20px;
  font-weight: 900;
  color: #00348b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: Montserrat-SemiBold;
}

.event_name {
  font-size: 36px;
  margin-top: 0px;
  font-weight: 900;
  color: #00348b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: Montserrat-SemiBold;
}

.scoreLable {
  font-size: 24px;
  margin-top: 0px;
  font-weight: 600;
  width: 300px;
  color: #e64f29;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: Montserrat-SemiBold;
}

.events-item {
  display: flex;
  align-items: center;
  width: 100%;
  height: 110px;
  margin-right: 45px;
  margin-bottom: 30px;
  margin-top: 15px;
  font-family: Montserrat-SemiBold;
  background: #e4eaff;
  position: relative;
}

.my-events {
  width: 100%;
  margin-top: 15px;
  margin-right: 45px;
}

.session-title {
  float: left;
  font-weight: 600;
  color: #fff;
  font-size: 18px;
  align-content: center;
  text-align: center;
  width: 150px;
  height: 40px;
  border-radius: 4px;
  background-color: #00348b;
  line-height: 40px;
  font-family: Montserrat-SemiBold;
  cursor: pointer;
}

.session-title1 {
  float: left;
  font-weight: 600;
  color: #2d50b0;
  font-size: 18px;
  align-content: center;
  text-align: center;
  width: 130px;
  margin-left: 10px;
  height: 38px;
  border-radius: 4px;
  background-color: white;
  line-height: 38px;
  font-family: Montserrat-SemiBold;
  border: 1px solid #00348b;
  cursor: pointer;
}
</style>
